import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FCLayout, AnthemLayout } from "@/components/Layouts";

import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import { Navigate } from "react-router-dom";
import BehindTheSongs from "@/pages/BehindTheSongs";
import EverydayAwareness from "@/pages/EverydayAwareness";
import GetInvolved from "@/pages/GetInvolved";
import Resources from "@/pages/Resources";
import ReadyQuiz from "@/pages/ReadyQuiz";
import Statistics from "@/pages/Statistics";
import MeetTheKids from "@/pages/kids/MeetTheKids";
import KidProfile from "@/pages/kids/KidProfile";

import AnthemHome from "@/pages/anthem/AnthemHome";
import Mission from "@/pages/anthem/Mission";
import Catalog from "@/pages/anthem/Catalog";
import Stories from "@/pages/anthem/Stories";
import Licensing from "@/pages/anthem/Licensing";
import SongDetail from "@/pages/anthem/SongDetail";
import WereComingForYou from "@/pages/anthem/WereComingForYou";

function FC({ children }) { return <FCLayout>{children}</FCLayout>; }
function AN({ children }) { return <AnthemLayout>{children}</AnthemLayout>; }

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FC><Home /></FC>} />
          <Route path="/contact" element={<FC><Contact /></FC>} />
          <Route path="/behind-the-songs" element={<FC><BehindTheSongs /></FC>} />
          <Route path="/everyday-awareness" element={<FC><EverydayAwareness /></FC>} />
          {/* Legacy redirect for old /awareness URL */}
          <Route path="/awareness" element={<Navigate to="/everyday-awareness" replace />} />
          <Route path="/get-involved" element={<FC><GetInvolved /></FC>} />
          <Route path="/resources" element={<FC><Resources /></FC>} />
          <Route path="/statistics" element={<FC><Statistics /></FC>} />
          <Route path="/am-i-ready-to-foster" element={<FC><ReadyQuiz /></FC>} />
          <Route path="/meet-the-kids" element={<FC><MeetTheKids /></FC>} />
          <Route path="/meet-the-kids/:slug" element={<FC><KidProfile /></FC>} />

          <Route path="/anthem" element={<AN><AnthemHome /></AN>} />
          <Route path="/anthem/mission" element={<AN><Mission /></AN>} />
          <Route path="/anthem/catalog" element={<AN><Catalog /></AN>} />
          <Route path="/anthem/stories" element={<AN><Stories /></AN>} />
          <Route path="/anthem/licensing" element={<AN><Licensing /></AN>} />
          <Route path="/anthem/song/:slug" element={<AN><SongDetail /></AN>} />
          <Route path="/anthem/were-coming-for-you" element={<AN><WereComingForYou /></AN>} />

          <Route path="*" element={<FC><Home /></FC>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
